import { AbstractMutableMapyktux9ubhc1g as AbstractMutableMap } from './AbstractMutableMap.mjs';
import { InternalHashMapmpvpylj0ut6l as InternalHashMap } from './InternalHashMap.mjs';
import {
  HashMapKeys28ggmxpft3hz9 as HashMapKeys,
  HashMapValues3umcxpfyfunqf as HashMapValues,
  HashMapEntrySet29p2ksc4wcy5i as HashMapEntrySet,
} from './HashMapEntry.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import { KtMutableMap1kqeifoi36kpz as KtMutableMap } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_collections_HashMap(_this__u8e3s4) {
  _this__u8e3s4.u8_1 = null;
}
var HashMapClass;
function HashMap() {
  if (HashMapClass === VOID) {
    class $ extends AbstractMutableMap() {
      static v8(internalMap) {
        var $this = this.v7();
        init_kotlin_collections_HashMap($this);
        $this.t8_1 = internalMap;
        return $this;
      }
      static w8() {
        return this.v8(InternalHashMap().h9());
      }
      static i9(initialCapacity, loadFactor) {
        return this.v8(InternalHashMap().j9(initialCapacity, loadFactor));
      }
      static k9(initialCapacity) {
        return this.i9(initialCapacity, 1.0);
      }
      static l9(original) {
        return this.v8(InternalHashMap().m9(original));
      }
      f5() {
        this.t8_1.f5();
      }
      x4(key) {
        return this.t8_1.n9(key);
      }
      y4(value) {
        return this.t8_1.y4(value);
      }
      z7() {
        return HashMapKeys().p9(this.t8_1);
      }
      c8() {
        return HashMapValues().r9(this.t8_1);
      }
      q3() {
        var tmp0_elvis_lhs = this.u8_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = HashMapEntrySet().t9(this.t8_1);
          this.u8_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      z4(key) {
        return this.t8_1.z4(key);
      }
      c5(key, value) {
        return this.t8_1.c5(key, value);
      }
      d5(key) {
        return this.t8_1.d5(key);
      }
      v2() {
        return this.t8_1.v2();
      }
      e5(from) {
        return this.t8_1.e5(from);
      }
    }
    initMetadataForClass($, 'HashMap', $.w8, VOID, [AbstractMutableMap(), KtMutableMap()]);
    HashMapClass = $;
  }
  return HashMapClass;
}
//region block: exports
export {
  HashMap as HashMap1a0ld5kgwhmhv,
};
//endregion

//# sourceMappingURL=HashMap.mjs.map
